import { getLoggedUser } from './../../utils/helpers/tokenStorage';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CurrentSessionT, UserT } from "../../models/models";

export interface AuthStateI {
  loggedUsers: UserT[];
  currentSession: CurrentSessionT | null;
  isChangingAccount: boolean;
}

const initialState: AuthStateI = {
  loggedUsers: [],
  currentSession: getLoggedUser()?.user || null,
  isChangingAccount: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<CurrentSessionT>) => {
      state.currentSession = action.payload;
    },
    logout: (state) => {
      state.currentSession = null;
      state.isChangingAccount = false;
    },
    setLoggedUsers: (state, action: PayloadAction<UserT[]>) => {
      state.loggedUsers = action.payload;
    },
    setIsChangingAccount: (state, action: PayloadAction<boolean>) => {
      state.isChangingAccount = action.payload;
    },
    setContactInfoConfirmed: (state, action: PayloadAction<boolean>) => {
      if (!state.currentSession?.user) return;
      state.currentSession.user.ContactInfoConfirmed = action.payload;
    },
  },
});

export const { login, logout, setLoggedUsers, setIsChangingAccount, setContactInfoConfirmed } = authSlice.actions;

export default authSlice.reducer;
